<template>
    <v-navigation-drawer app>
        <!-- :expand-on-hover="$vuetify.breakpoint.mdAndDown" permanent -->
        <template v-slot:prepend>
            <v-list-item two-line>
                <v-list-item-avatar>
                    <!-- <img src="" /> -->
                    <v-img src="@/assets/img/user-icon.svg"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>{{ userInfo.first_name + ' ' + userInfo.last_name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ userInfo.role.name }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </template>

        <v-list dense class="navigation">
            <template v-for="(item, index) in navMenu">
                <v-divider v-if="item.divider" :key="index" class="mx-3"></v-divider>
                <v-list-item v-else :key="index" :to="item.to" @click="item.title == 'Logout' ? logout() : ''" color="primary">
                    <v-list-item-icon>
                        <div v-if="item.icon" class="v-icon v-icon-fill" v-html="require(`!html-loader!@/assets/img/${item.icon}.svg`)"></div>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>

        <v-footer absolute color="white" class="mx-n1">
            <v-col class="text-center" v-html="require(`!html-loader!@/assets/img/logo.svg`)"></v-col>
        </v-footer>
    </v-navigation-drawer>
</template>

<script>
export default {
    props: {
        getMyyInfo: {
            type: Object
        }
    },
    data() {
        return {
            navMenu: []
        };
    },
    computed: {
        userInfo() {
            return this.$store.getters['authentication/getUserInfo'];
        }
    },
    methods: {
        initiate() {
            this.events();
            this.createNavigation();
        },
        events() {
            this.$eventBus.$on('logout', this.logout);
        },
        logout() {
            this.$store.dispatch('authentication/logout').then(this.clearData).catch(this.clearData);
        },
        clearData() {
            this.$eventBus.$emit('clear-data');
        },
        createNavigation() {
            // Get all permissions/action_id that have suffix index
            const convertPermission = Object.fromEntries(Object.entries(this.getMyyInfo.permissions).filter(([key]) => key.includes('index')));

            const convertPermissionsToProperty = Object.keys(convertPermission);

            var merchantsActionID = '';
            if (convertPermissionsToProperty.indexOf('merchants-index') > -1) {
                merchantsActionID = 'merchants-index';
            } else if (convertPermissionsToProperty.indexOf('merchants-index-limited_by_partner') > -1) {
                merchantsActionID = 'merchants-index-limited_by_partner';
            } else {
                merchantsActionID = 'n/a';
            }

            // this.getActionIdByRoleId(this.getMyyInfo.role.id, "ADMIN", 'merchants-index', 'merchants-index-limited_by_assigned_merchant')
            const navigationDefaultItems = [
                {
                    title: 'Merchants',
                    icon: 'merchant',
                    to: '/merchants',
                    // action_id: this.getMyyInfo.role.id === 'ADMIN' ? 'merchants-index' : this.getMyyInfo.role.id === 'PARTNER' ? 'merchants-index-limited_by_assigned_merchant' : 'n/a',
                    action_id: merchantsActionID,
                    sequence: 0,
                    submodule: ['import_file_uploads-index']
                },
                { title: 'My QR', icon: 'my-qr', to: '/my-qr', action_id: this.getMyyInfo.role.id === 'MERCHANT' ? 'my-merchant-index' : 'n/a', sequence: 1 },
                { title: 'Branches', icon: 'merchant', to: '/branches', action_id: this.getMyyInfo.role.id === 'MERCHANT' ? 'my-merchant-branches-index' : 'n/a', sequence: 2 },
                { title: 'Audit Trail', icon: 'audit-trails', to: '/audit-trails', action_id: 'cms_audit_logs-index', sequence: 3 },
                {
                    title: 'User Access',
                    icon: 'user-access',
                    to: '/user-access',
                    action_id: 'cms_users-index',
                    submodule: ['cms_users-roles-index', 'cms_roles-users-index', 'cms_roles-index'],
                    sequence: 5
                },
                { title: 'System Variables', icon: 'user-access', to: '/system-variables', action_id: 'merchant-branches-index', sequence: 6 }
            ];

            if (Object.keys(convertPermission).length > 0) {
                this.navMenu = navigationDefaultItems.filter((o1) => convertPermissionsToProperty.some((o2) => o2 === o1.action_id));
                let combineSubmodule = [];
                let output = [];

                this.navMenu.map((p) => {
                    if (p.submodule) {
                        p.submodule.filter((i) => {
                            convertPermissionsToProperty.some((o2) => {
                                if (o2 === i) {
                                    combineSubmodule.push({
                                        action_id: p.action_id,
                                        submodule: i
                                    });
                                }
                            });
                        });
                    }
                });

                combineSubmodule.forEach(function (item) {
                    var existing = output.filter(function (v) {
                        return v.action_id == item.action_id;
                    });
                    if (existing.length) {
                        var existingIndex = output.indexOf(existing[0]);
                        output[existingIndex].submodule = output[existingIndex].submodule.concat(item.submodule);
                    } else {
                        if (typeof item.submodule == 'string') item.submodule = [item.submodule];
                        output.push(item);
                    }
                });

                this.navMenu.forEach((item) => {
                    output.forEach((i) => {
                        if (item.action_id === i.action_id) {
                            item.submodule = i.submodule;
                        }
                    });
                });
            }

            this.navMenu.push({ divider: true, inset: true, action_id: 'merchant-branches-index', sequence: 4 });
            this.navMenu.push({ title: 'Logout', icon: 'logout', action_id: 'logout', sequence: 7 });

            this.navMenu.sort(function (a, b) {
                return a.sequence - b.sequence || a.action_id.localeCompare(b.action_id);
            });
        }
    },
    mounted() {
        this.initiate();
    },
    beforeDestroy() {
        this.$eventBus.$off('logout');
    }
};
</script>

<style lang="scss">
.v-list.navigation {
    padding: 0;

    .v-list-item {
        padding: 5px 16px;

        .v-list-item__icon {
            margin-right: 20px;

            .v-icon {
                margin-left: 4px;
                svg {
                    width: 20px;
                    height: 20px;
                }

                &.v-icon-fill {
                    svg {
                        path {
                            fill: #848c9c;
                        }

                        rect {
                            fill: #848c9c;
                        }

                        circle {
                            fill: #848c9c;
                        }
                    }
                }

                &.v-icon-stroke {
                    svg {
                        path {
                            stroke: #848c9c;
                        }

                        rect {
                            stroke: #848c9c;
                        }

                        circle {
                            stroke: #848c9c;
                        }
                    }
                }
            }
        }

        .v-list-item__title {
            color: #425466;
        }
    }

    .v-list-item--active.v-list-item {
        &.theme--light {
            background-color: var(--v-secondaryBackgroundColor-base);
        }

        &.theme--dark {
            background-color: var(--v-secondaryBackgroundColor-base);
        }

        .v-list-item__icon {
            .v-icon-fill {
                svg {
                    path {
                        fill: var(--v-primary-base) !important;
                    }

                    rect {
                        fill: var(--v-primary-base) !important;
                    }

                    circle {
                        fill: var(--v-primary-base) !important;
                    }
                }
            }

            .v-icon-stroke {
                svg {
                    path {
                        stroke: var(--v-primary-base);
                    }

                    rect {
                        stroke: var(--v-primary-base);
                    }

                    circle {
                        stroke: var(--v-primary-base);
                    }
                }
            }
        }

        .v-list-item__title {
            color: #4c6fff;
        }
    }
}
</style>
